import { Grid, Stack, Switch, Typography } from "@mui/material";
import React from "react";
import { useSelector } from "react-redux";
import HorizontalFill from "../../../../../shared/components/HorizontalFill";
import Conditions from "../../../../../shared/reporting/components/viewer/common/conditions/Conditions";
import { CellDrillDownInfoBase } from "../../../../api/biApi.types";
import { DrillDownState } from "../../../../hooks/useDrillDown";
import { selectDimensions } from "../../../../store/selectors/metaDataSelectors";
import { DrillDownPage } from "../../../../store/types/drillDownPageState.types";

interface Props {
  state: DrillDownState;
  configuration: DrillDownPage;
  info: CellDrillDownInfoBase;
}

export default function ReadonlyConditions({ state, configuration, info }: Props) {
  const dimensions = useSelector(selectDimensions);
  const [detailedView, setDetailedView] = React.useState(true);

  if (!configuration || !info?.conditions || info.conditions.length === 0) {
    return <></>;
  }

  return (
    <Grid sx={{ flexDirection: "column", width: "100%" }}>
      <Stack direction={"row"} alignItems="center" gap={0.5}>
        <Typography variant="subtitle2">Conditions</Typography>
        <HorizontalFill />
        <Typography>Detailed View</Typography>
        <Switch checked={detailedView} onChange={(_, value) => setDetailedView(value)}></Switch>
      </Stack>
      <Grid container sx={{ pt: 2, width: "100%" }}>
        <Conditions
          conditions={state.conditions}
          detailed={detailedView}
          readonly
          canBeRemoved={false}
          onRemoveFields={state.actions.removeCondition}
          onFieldChanged={state.actions.updateCondition}
          dimensions={dimensions}
        />
      </Grid>
    </Grid>
  );
}
